import { call, put, takeEvery } from "redux-saga/effects";
import Swal from "sweetalert2";

import { getCookie } from "../../../../store/localStorage";
import * as types from "./dropdownMgmtActionType";
import * as dropdownMgmtServices from "./dropdownMgmtServices";
import * as actions from "./dropdownMgmtAction";
import SweetAlert from "../../../../components/sweetalert/SweetAlert";

//------------------Provider Type------------------//
// Worker saga: will be fired on FETCH_RADTYPES_REQUEST actions
function* fetchRadTypesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllRadTypes);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchRadTypesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch provider Types";

    console.error("Provider Type API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRadTypesFailure(errorMessage));
  }
}

// Worker saga for delete provider Type
function* deleteRadTypeSaga(action) {
  try {
    const { radTypeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRadType,
      radTypeId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteRadTypeSuccess(radTypeId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted provider Type.",
      });
      yield put(actions.fetchRadTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete provider Type.";
      yield put(actions.deleteRadTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete provider Type.";
    yield put(actions.deleteRadTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save provider Type
function* saveRadTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveRadType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveRadTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved provider Type.",
      });
      yield put(actions.fetchRadTypesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save provider Type.";
      yield put(actions.saveRadTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save provider Type.";
    yield put(actions.saveRadTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for fetch provider Type by ID
function* fetchRadTypeByIdSaga(action) {
  try {
    const { radTypeId } = action.payload;
    const response = yield call(dropdownMgmtServices.getRadTypeById, radTypeId);
    yield put(actions.fetchRadTypeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider Type details.";
    yield put(actions.fetchRadTypeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for update provider Type
function* updateRadTypeSaga(action) {
  try {
    const radTypeData = action.payload;
    const userData = yield call(getCookie, "userData");
    const userId = userData?.UserId || userData?.UserID || 10;
    const payload = {
      radTypeID: radTypeData.radTypeID || radTypeData.radTypeId,
      radTypeName: radTypeData.radTypeName,
      radTypeCode: radTypeData.radTypeCode || "",
      isActive: radTypeData.isActive,
      ModifiedBy: userId,
    };
    const response = yield call(dropdownMgmtServices.updateRadType, payload);
    if (response?.success) {
      yield put(actions.updateRadTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Updated provider Type.",
      });
      yield put(actions.fetchRadTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to update provider Type.";
      yield put(actions.updateRadTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider Type.";
    yield put(actions.updateRadTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate provider Type
function* activateDeactivateRadTypeSaga(action) {
  try {
    const { radTypeId, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRadType,
      radTypeId,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateRadTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider Type has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchRadTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} provider Type.`;
      yield put(actions.activateDeactivateRadTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider Type status.";
    yield put(actions.activateDeactivateRadTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Provider Status------------------//
// Worker saga: will be fired on FETCH_RADSTATUS_REQUEST actions
function* fetchRadStatusSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllRadStatus);
    if (!response) {
      throw new Error("No response received from API");
    }

    console.log("fetchRadStatusSaga response", response);

    // Dispatch success action with the data
    yield put(actions.fetchRadStatusSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch provider status";

    console.error("Provider status API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRadStatusFailure(errorMessage));
  }
}

// Worker saga for save provider status (both create and update)
function* saveRadStatusSaga(action) {
  try {
    const radStatusData = action.payload;
    const response = yield call(
      dropdownMgmtServices.saveRadStatus,
      radStatusData,
    );
    if (response?.success) {
      yield put(actions.saveRadStatusSuccess(response?.values));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Provider status saved successfully.",
      });
      yield put(actions.fetchRadStatusRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save provider status.";
      yield put(actions.saveRadStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save provider status.";
    yield put(actions.saveRadStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete provider status
function* deleteRadStatusSaga(action) {
  try {
    const { radStatusId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRadStatus,
      radStatusId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteRadStatusSuccess(radStatusId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Provider status deleted successfully.",
      });
      yield put(actions.fetchRadStatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete provider status.";
      yield put(actions.deleteRadStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete provider status.";
    yield put(actions.deleteRadStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for fetch provider status by ID
function* fetchRadStatusByIdSaga(action) {
  try {
    const radStatusId = action.payload;
    const response = yield call(
      dropdownMgmtServices.getRadStatusById,
      radStatusId,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchRadStatusByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider status details.";
    yield put(actions.fetchRadStatusByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for update provider status
function* updateRadStatusSaga(action) {
  try {
    const radStatusData = action.payload;
    const response = yield call(
      dropdownMgmtServices.updateRadStatus,
      radStatusData,
    );
    if (response?.success) {
      yield put(actions.updateRadStatusSuccess(response?.values));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Provider status updated successfully.",
      });
      yield put(actions.fetchRadStatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to update provider status.";
      yield put(actions.updateRadStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider status.";
    yield put(actions.updateRadStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate provider status
function* activateDeactivateRadStatusSaga(action) {
  try {
    const { radStatusId, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRadStatus,
      radStatusId,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateRadStatusSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider status has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchRadStatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} provider status.`;
      yield put(actions.activateDeactivateRadStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider status status.";
    yield put(actions.activateDeactivateRadStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------RadCommunicationType------------------//
//get all RadCommunicationTypes
function* fetchRadCommunicationTypeSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(
      dropdownMgmtServices.getAllRadCommunicationTypes,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchRadCommunicationTypeSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch provider Communication Type";

    console.error("Provider Communication Type API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRadCommunicationTypeFailure(errorMessage));
  }
}

// get by ID RadCommunicationType
function* fetchRadCommunicationTypeByIdSaga(action) {
  try {
    const { RadCommunicationTypeID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getRadCommunicationTypeById,
      RadCommunicationTypeID,
    );
    yield put(actions.fetchRadCommunicationTypeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider Communication Type details.";
    yield put(actions.fetchRadCommunicationTypeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// save RadCommunicationType
function* saveRadCommunicationTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveRadCommunicationType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveRadCommunicationTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Saved provider Communication Type.",
      });
      yield put(actions.fetchRadCommunicationTypeRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save provider Communication Type.";
      yield put(actions.saveRadCommunicationTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save provider Communication Type.";
    yield put(actions.saveRadCommunicationTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// delete RadCommunicationType
function* deleteRadCommunicationTypeSaga(action) {
  try {
    const { radCommunicationTypeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRadCommunicationType,
      radCommunicationTypeId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(
        actions.deleteRadCommunicationTypeSuccess(radCommunicationTypeId),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Deleted provider Communication Type.",
      });
      yield put(actions.fetchRadCommunicationTypeRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        "Failed to delete provider Communication Type.";
      yield put(actions.deleteRadCommunicationTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete provider Communication Type.";
    yield put(actions.deleteRadCommunicationTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// activate/deactivate RadCommunicationType
function* activateDeactivateRadCommunicationTypeSaga(action) {
  try {
    const { radCommunicationTypeId, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRadCommunicationType,
      radCommunicationTypeId,
      status,
      userId,
    );
    if (response?.success) {
      yield put(
        actions.activateDeactivateRadCommunicationTypeSuccess(response),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider Communication Type has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchRadCommunicationTypeRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} provider Communication Type.`;
      yield put(
        actions.activateDeactivateRadCommunicationTypeFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider Communication Type status.";
    yield put(
      actions.activateDeactivateRadCommunicationTypeFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------RadDegree - Sagas------------------//
// Worker saga for getAll actions
function* fetchRadDegreeSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllRadDegree);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchRadDegreeSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch provider designation";

    console.error("Provider Designation API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRadDegreeFailure(errorMessage));
  }
}

// Worker saga for fetch provider designation by ID
function* fetchRadDegreeByIdSaga(action) {
  try {
    const { RadDegreeID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getRadDegreeById,
      RadDegreeID,
    );
    yield put(actions.fetchRadDegreeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider designation details.";
    yield put(actions.fetchRadDegreeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save provider designation
function* saveRadDegreeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveRadDegree,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveRadDegreeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully saved provider designation.",
      });
      yield put(actions.fetchRadDegreeRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save provider designation.";
      yield put(actions.saveRadDegreeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save provider designation.";
    yield put(actions.saveRadDegreeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete provider designation
function* deleteRadDegreeSaga(action) {
  try {
    const { RadDegreeID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRadDegree,
      RadDegreeID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteRadDegreeSuccess(RadDegreeID));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully deleted provider designation.",
      });
      yield put(actions.fetchRadDegreeRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete provider designation.";
      yield put(actions.deleteRadDegreeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete provider designation.";
    yield put(actions.deleteRadDegreeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate provider designation
function* activateDeactivateRadDegreeSaga(action) {
  try {
    const { RadDegreeID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRadDegree,
      RadDegreeID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateRadDegreeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider designation has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchRadDegreeRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} provider designation.`;
      yield put(actions.activateDeactivateRadDegreeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider designation status.";
    yield put(actions.activateDeactivateRadDegreeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Designation Lookup - Saga------------------//
// Worker saga for fetching the Designation dropdown source used by the
// Add/Edit Designation form. Reuses the existing Designation/GetAllDesignation
// API (Master_RadUserRole, tenant DB) -- values.lstDesignation, each entry
// shaped { RADUserRoleID, DesignationName, RoleCode }.
function* fetchDesignationLookupSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getDesignationLookup);
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(
      actions.fetchDesignationLookupSuccess(response?.values?.lstDesignation),
    );
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch designation dropdown.";
    yield put(actions.fetchDesignationLookupFailure(errorMessage));
  }
}

//------------------Designation - Sagas------------------//
// Worker saga for getAll actions
function* fetchDesignationSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllDesignation);
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.fetchDesignationSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch designation";

    console.error("Designation API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    yield put(actions.fetchDesignationFailure(errorMessage));
  }
}

// Worker saga for fetch designation by ID
function* fetchDesignationByIdSaga(action) {
  try {
    const { RADUserID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getDesignationById,
      RADUserID,
    );
    yield put(actions.fetchDesignationByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch designation details.";
    yield put(actions.fetchDesignationByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save designation
function* saveDesignationSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveDesignation,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveDesignationSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully saved designation.",
      });
      yield put(actions.fetchDesignationRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save designation.";
      yield put(actions.saveDesignationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save designation.";
    yield put(actions.saveDesignationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete designation
function* deleteDesignationSaga(action) {
  try {
    const { RADUserID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteDesignation,
      RADUserID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteDesignationSuccess(RADUserID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully deleted designation.",
      });
      yield put(actions.fetchDesignationRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete designation.";
      yield put(actions.deleteDesignationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete designation.";
    yield put(actions.deleteDesignationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate designation
function* activateDeactivateDesignationSaga(action) {
  try {
    const { RADUserID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateDesignation,
      RADUserID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateDesignationSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Designation has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchDesignationRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} designation.`;
      yield put(actions.activateDeactivateDesignationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update designation status.";
    yield put(actions.activateDeactivateDesignationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Committees - Sagas------------------//
// Worker saga for getAll actions
function* fetchCommitteesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllCommittees);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchCommitteesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch committees";

    console.error("Committees API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchCommitteesFailure(errorMessage));
  }
}

// Worker saga for fetch committees by ID
function* fetchCommitteesByIdSaga(action) {
  try {
    const { RadCommitteeID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getCommitteesById,
      RadCommitteeID,
    );
    yield put(actions.fetchCommitteesByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider committees details.";
    yield put(actions.fetchCommitteesByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save committee
function* saveCommitteesSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveCommittees,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveCommitteesSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully saved committees.",
      });
      yield put(actions.fetchCommitteesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save committees.";
      yield put(actions.saveCommitteesFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save committees.";
    yield put(actions.saveCommitteesFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete committee
function* deleteCommitteesSaga(action) {
  try {
    const { RadCommitteeID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteCommittees,
      RadCommitteeID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteCommitteesSuccess(RadCommitteeID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Committees.",
      });
      yield put(actions.fetchCommitteesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete committees.";
      yield put(actions.deleteCommitteesFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete committees.";
    yield put(actions.deleteCommitteesFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate committees
function* activateDeactivateCommitteesSaga(action) {
  try {
    const { RadCommitteeID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateCommittees,
      RadCommitteeID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateCommitteesSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider Committees has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchCommitteesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} provider committees.`;
      yield put(actions.activateDeactivateCommitteesFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider committees status.";
    yield put(actions.activateDeactivateCommitteesFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------FutureSectionChange - Sagas ------------------//
// Worker saga for getAll actions
function* fetchFutureSectionChangeSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllFutureSectionChange);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchFutureSectionChangeSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch future section changes";

    console.error("Future Section Change API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchFutureSectionChangeFailure(errorMessage));
  }
}

// Worker saga for fetch future section change by ID
function* fetchFutureSectionChangeByIdSaga(action) {
  try {
    const { RadScheduleFutureSectionID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getFutureSectionChangeById,
      RadScheduleFutureSectionID,
    );
    yield put(actions.fetchFutureSectionChangeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch future section change details.";
    yield put(actions.fetchFutureSectionChangeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save future section change
function* saveFutureSectionChangeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveFutureSectionChange,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveFutureSectionChangeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Saved Future Section Change.",
      });
      yield put(actions.fetchFutureSectionChangeRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save future section change.";
      yield put(actions.saveFutureSectionChangeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save future section change.";
    yield put(actions.saveFutureSectionChangeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete future section change
function* deleteFutureSectionChangeSaga(action) {
  try {
    const { RadScheduleFutureSectionID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteFutureSectionChange,
      RadScheduleFutureSectionID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(
        actions.deleteFutureSectionChangeSuccess(RadScheduleFutureSectionID),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Deleted Future Section Change.",
      });
      yield put(actions.fetchFutureSectionChangeRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete future section change.";
      yield put(actions.deleteFutureSectionChangeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete future section change.";
    yield put(actions.deleteFutureSectionChangeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate future section change
function* activateDeactivateFutureSectionChangeSaga(action) {
  try {
    const { RadScheduleFutureSectionID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateFutureSectionChange,
      RadScheduleFutureSectionID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateFutureSectionChangeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Future Section Change has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchFutureSectionChangeRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} future section change.`;
      yield put(
        actions.activateDeactivateFutureSectionChangeFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update future section change status.";
    yield put(
      actions.activateDeactivateFutureSectionChangeFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// --------------------- Subspeciality Sagas ------------------ //
function* fetchSubspecialitiesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllSubspecialities);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchSubspecialitiesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch subspecialities";

    console.error("Subspeciality API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchSubspecialitiesFailure(errorMessage));
  }
}

function* fetchSubspecialityByIdSaga(action) {
  try {
    // Call the API

    const response = yield call(
      dropdownMgmtServices.getSubspecialityById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchSubspecialityByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch subspeciality details";

    console.error("Fetch Subspeciality By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchSubspecialityByIdFailure(errorMessage));
  }
}

function* saveSubspecialitySaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveSubspeciality,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveSubspecialitySuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Subspeciality.",
      });
      yield put(actions.fetchSubspecialitiesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save subspeciality.";
      yield put(actions.saveSubspecialityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save subspeciality.";
    yield put(actions.saveSubspecialityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteSubspecialitySaga(action) {
  try {
    const { subspecialityId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteSubspeciality,
      subspecialityId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteSubspecialitySuccess(subspecialityId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Subspeciality.",
      });
      yield put(actions.fetchSubspecialitiesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete subspeciality.";
      yield put(actions.deleteSubspecialityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete subspeciality.";
    yield put(actions.deleteSubspecialityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateSubspecialitySaga(action) {
  try {
    const { subspecialityId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateSubspeciality,
      subspecialityId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateSubspecialitySuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Subspeciality.`,
      });
      yield put(actions.fetchSubspecialitiesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} subspeciality.`;
      yield put(actions.activateDeactivateSubspecialityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update subspeciality status.";
    yield put(actions.activateDeactivateSubspecialityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// --------------------- Billing Management Sagas ------------------ //
function* fetchBillingManagementSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllBillingManagement);
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.fetchBillingManagementSuccess(response?.values));
  } catch (error) {
    const errorMessage = "Failed to fetch billing management records";
    yield put(actions.fetchBillingManagementFailure(errorMessage));
  }
}

function* fetchBillingManagementByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getBillingManagementById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.fetchBillingManagementByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage = "Failed to fetch billing management details";
    yield put(actions.fetchBillingManagementByIdFailure(errorMessage));
  }
}

function* saveBillingManagementSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveBillingManagement,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveBillingManagementSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully Saved Billing Management.",
      });
      yield put(actions.fetchBillingManagementRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save billing management.";
      yield put(actions.saveBillingManagementFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save billing management.";
    yield put(actions.saveBillingManagementFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteBillingManagementSaga(action) {
  try {
    const { billingManagementId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteBillingManagement,
      billingManagementId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteBillingManagementSuccess(billingManagementId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Deleted Billing Management.",
      });
      yield put(actions.fetchBillingManagementRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete billing management.";
      yield put(actions.deleteBillingManagementFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete billing management.";
    yield put(actions.deleteBillingManagementFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateBillingManagementSaga(action) {
  try {
    const { billingManagementId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateBillingManagement,
      billingManagementId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateBillingManagementSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Billing Management.`,
      });
      yield put(actions.fetchBillingManagementRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} billing management.`;
      yield put(actions.activateDeactivateBillingManagementFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update billing management status.";
    yield put(actions.activateDeactivateBillingManagementFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// --------------- RVU RATE SECTION ------------------//
function* fetchRvuRateRequestsSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.fetchRvuRateRequests);
    if (!response) {
      throw new Error("No response received from API");
    }

    console.log("🔍 RVU Rate API Response:", response);

    // Extract the correct array from the response structure
    // The API returns { listRadRUVRate: [...] } so we need to extract that array
    const rvuRateList = response?.values.listRadRUVRate || [];

    // Dispatch success action with the extracted array
    yield put(actions.fetchRvuRateSuccess(rvuRateList));
  } catch (error) {
    let errorMessage = "Failed to fetch RVU Rates";

    console.error("RVU Rate API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRvuRateFailure(errorMessage));
  }
}

function* fetchRvuRateByIdSaga(action) {
  try {
    // Support both primitive and object payloads
    let RadRUVRateID;
    if (
      typeof action.payload === "object" &&
      action.payload !== null &&
      "RadRUVRateID" in action.payload
    ) {
      RadRUVRateID = action.payload.RadRUVRateID;
    } else {
      RadRUVRateID = action.payload;
    }

    console.log("check", action.payload);

    // Call the API
    const response = yield call(
      dropdownMgmtServices.getRvuRateById,
      RadRUVRateID,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchRvuRateByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch RVU rate details";

    console.error("RVU Rate By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRvuRateByIdFailure(errorMessage));
  }
}

function* saveRvuRateRequestsSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveRvuRate,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveRvuRateSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved RVU Rate.",
      });
      yield put(actions.fetchRvuRateRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage = response?.errorMessage || "Failed to save RVU rate.";
      yield put(actions.saveRvuRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save RVU rate.";
    yield put(actions.saveRvuRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteRvuRateRequestsSaga(action) {
  try {
    const { rvuRateId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRvuRate,
      rvuRateId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteRvuRateSuccess(rvuRateId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted RVU Rate.",
      });
      yield put(actions.fetchRvuRateRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete RVU Rate.";
      yield put(actions.deleteRvuRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete RVU Rate.";
    yield put(actions.deleteRvuRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateRvuRateRequestsSaga(action) {
  try {
    const { rvuRateId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRvuRate,
      rvuRateId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateRvuRateSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} RVU Rate.`,
      });
      yield put(actions.fetchRvuRateRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} RVU Rate.`;
      yield put(actions.activateDeactivateRvuRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update RVU Rate status.";
    yield put(actions.activateDeactivateRvuRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//-------------- Week Rotation Sagas -----------------//
function* fetchWeekRotationsSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllWeekRotations);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchWeekRotationsSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch week rotations";

    console.error("Week Rotation API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchWeekRotationsFailure(errorMessage));
  }
}

function* fetchWeekRotationByIdSaga(action) {
  try {
    const { weekRotationId } = action.payload;
    // Call the API
    const response = yield call(
      dropdownMgmtServices.getWeekRotationById,
      weekRotationId,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    // Dispatch success action with the data
    yield put(actions.fetchWeekRotationByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch week rotation details";
    console.error("Fetch Week Rotation By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    // Dispatch failure action with error
    yield put(actions.fetchWeekRotationByIdFailure(errorMessage));
  }
}

function* saveWeekRotationSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveWeekRotation,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveWeekRotationSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Week Rotation.",
      });
      yield put(actions.fetchWeekRotationsRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save week rotation.";
      yield put(actions.saveWeekRotationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save week rotation.";
    yield put(actions.saveWeekRotationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteWeekRotationSaga(action) {
  try {
    const { weekRotationId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteWeekRotation,
      weekRotationId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteWeekRotationSuccess(weekRotationId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Week Rotation.",
      });
      yield put(actions.fetchWeekRotationsRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete week rotation.";
      yield put(actions.deleteWeekRotationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete week rotation.";
    yield put(actions.deleteWeekRotationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateWeekRotationSaga(action) {
  try {
    const { Id, Status, UserId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateWeekRotation,
      Id,
      Status,
      UserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateWeekRotationSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Week Rotation.`,
      });
      yield put(actions.fetchWeekRotationsRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${Status ? "activate" : "deactivate"} week rotation.`;
      yield put(actions.activateDeactivateWeekRotationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update week rotation status.";
    yield put(actions.activateDeactivateWeekRotationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//-------------- Week Rotation Template Sagas -----------------//
function* fetchWeekRotationTemplatesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(
      dropdownMgmtServices.getAllWeekRotationTemplates,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchWeekRotationTemplatesSuccess(response));
  } catch (error) {
    let errorMessage = "Failed to fetch week rotation templates";

    console.error("Week Rotation Template API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchWeekRotationTemplatesFailure(errorMessage));
  }
}

function* fetchWeekRotationTemplateByIdSaga(action) {
  try {
    const { templateId } = action.payload;

    // Call the API
    const response = yield call(
      dropdownMgmtServices.getWeekRotationTemplateById,
      templateId,
    );

    // Dispatch success action
    yield put(actions.fetchWeekRotationTemplateByIdSuccess(response.values));
  } catch (error) {
    let errorMessage = "Failed to fetch week rotation template details";

    console.error("Fetch Week Rotation Template By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchWeekRotationTemplateByIdFailure(errorMessage));
  }
}

function* saveWeekRotationTemplateSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveWeekRotationTemplate,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveWeekRotationTemplateSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Saved Week Rotation Template.",
      });
      yield put(actions.fetchWeekRotationTemplatesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save week rotation template.";
      yield put(actions.saveWeekRotationTemplateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save week rotation template.";
    yield put(actions.saveWeekRotationTemplateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteWeekRotationTemplateSaga(action) {
  try {
    const { templateId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteWeekRotationTemplate,
      templateId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteWeekRotationTemplateSuccess(templateId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully Deleted Week Rotation Template.",
      });
      yield put(actions.fetchWeekRotationTemplatesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete week rotation template.";
      yield put(actions.deleteWeekRotationTemplateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete week rotation template.";
    yield put(actions.deleteWeekRotationTemplateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateWeekRotationTemplateSaga(action) {
  try {
    const { templateId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateWeekRotationTemplate,
      templateId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateWeekRotationTemplateSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Week Rotation Template.`,
      });
      yield put(actions.fetchWeekRotationTemplatesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} week rotation template.`;
      yield put(
        actions.activateDeactivateWeekRotationTemplateFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update week rotation template status.";
    yield put(
      actions.activateDeactivateWeekRotationTemplateFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// ---------------- Partnership Rate Sagas ------------------//
function* fetchPartnershipRatesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllPartnershipRates);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipRatesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership rates";

    console.error("Partnership Rate API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipRatesFailure(errorMessage));
  }
}

function* fetchPartnershipRateByIdSaga(action) {
  try {
    // Call the API
    const response = yield call(
      dropdownMgmtServices.getPartnershipRateById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipRateByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership rate details";

    console.error("Fetch Partnership Rate By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipRateByIdFailure(errorMessage));
  }
}

function* savePartnershipRateSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.savePartnershipRate,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.savePartnershipRateSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Partnership Rate.",
      });
      yield put(actions.fetchPartnershipRatesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save partnership rate.";
      yield put(actions.savePartnershipRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save partnership rate.";
    yield put(actions.savePartnershipRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deletePartnershipRateSaga(action) {
  try {
    const { partnershipRateId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deletePartnershipRate,
      partnershipRateId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deletePartnershipRateSuccess(partnershipRateId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully Deleted Partnership Rate.",
      });
      yield put(actions.fetchPartnershipRatesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete partnership rate.";
      yield put(actions.deletePartnershipRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete partnership rate.";
    yield put(actions.deletePartnershipRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivatePartnershipRateSaga(action) {
  try {
    const { partnershipRateId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivatePartnershipRate,
      partnershipRateId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivatePartnershipRateSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Partnership Rate.`,
      });
      yield put(actions.fetchPartnershipRatesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} partnership rate.`;
      yield put(actions.activateDeactivatePartnershipRateFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update partnership rate status.";
    yield put(actions.activateDeactivatePartnershipRateFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// ---------------- Partnership Status Sagas ------------------//
function* fetchPartnershipStatusesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllPartnershipStatuses);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipStatusesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership statuses";

    console.error("Partnership Status API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipStatusesFailure(errorMessage));
  }
}

function* fetchPartnershipStatusByIdSaga(action) {
  try {
    // Call the API
    const response = yield call(
      dropdownMgmtServices.getPartnershipStatusById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipStatusByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership status details";

    console.error("Fetch Partnership Status By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipStatusByIdFailure(errorMessage));
  }
}

function* savePartnershipStatusSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.savePartnershipStatus,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.savePartnershipStatusSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully Saved Partnership Status.",
      });
      yield put(actions.fetchPartnershipStatusesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save partnership status.";
      yield put(actions.savePartnershipStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save partnership status.";
    yield put(actions.savePartnershipStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deletePartnershipStatusSaga(action) {
  try {
    const { partnershipStatusId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deletePartnershipStatus,
      partnershipStatusId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deletePartnershipStatusSuccess(partnershipStatusId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully Deleted Partnership Status.",
      });
      yield put(actions.fetchPartnershipStatusesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete partnership status.";
      yield put(actions.deletePartnershipStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete partnership status.";
    yield put(actions.deletePartnershipStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivatePartnershipStatusSaga(action) {
  try {
    const { partnershipStatusId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivatePartnershipStatus,
      partnershipStatusId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivatePartnershipStatusSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Partnership Status.`,
      });
      yield put(actions.fetchPartnershipStatusesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} partnership status.`;
      yield put(
        actions.activateDeactivatePartnershipStatusFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update partnership status status.";
    yield put(actions.activateDeactivatePartnershipStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// -------------------Partnership Time Sagas -------------------//
function* fetchPartnershipTimesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllPartnershipTimes);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipTimesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership times";

    console.error("Partnership Time API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipTimesFailure(errorMessage));
  }
}

function* fetchPartnershipTimeByIdSaga(action) {
  try {
    // Call the API

    const response = yield call(
      dropdownMgmtServices.getPartnershipTimeById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchPartnershipTimeByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch partnership time details";

    console.error("Partnership Time By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchPartnershipTimeByIdFailure(errorMessage));
  }
}

function* savePartnershipTimeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.savePartnershipTime,
      action.payload,
    );
    if (response?.success) {
      yield put(
        actions.savePartnershipTimeSuccess(
          response?.message || "Partnership time saved successfully",
        ),
      );
      const isEdit = action.payload.RadPartnershipTimeID;
      const actionText = isEdit ? "updated" : "saved";
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${actionText} Partnership Time.`,
      });
      yield put(actions.fetchPartnershipTimesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save partnership time.";
      yield put(actions.savePartnershipTimeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save partnership time.";
    yield put(actions.savePartnershipTimeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deletePartnershipTimeSaga(action) {
  try {
    const { partnershipTimeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deletePartnershipTime,
      partnershipTimeId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deletePartnershipTimeSuccess(partnershipTimeId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully Deleted Partnership Time.",
      });
      yield put(actions.fetchPartnershipTimesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete partnership time.";
      yield put(actions.deletePartnershipTimeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete partnership time.";
    yield put(actions.deletePartnershipTimeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivatePartnershipTimeSaga(action) {
  try {
    const { partnershipTimeId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivatePartnershipTime,
      partnershipTimeId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivatePartnershipTimeSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Partnership Time.`,
      });
      yield put(actions.fetchPartnershipTimesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} partnership time.`;
      yield put(actions.activateDeactivatePartnershipTimeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update partnership time status.";
    yield put(actions.activateDeactivatePartnershipTimeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------ScheduleType------------------//
// Worker saga: will be fired on FETCH_SCHEDULETYPE_REQUEST actions
function* fetchScheduleTypeSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllScheduleTypes);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchScheduleTypeSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch worklist";

    console.error("Region API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchScheduleTypeFailure(errorMessage));
  }
}

// Worker saga for fetch schedule type by ID
function* fetchScheduleTypeByIdSaga(action) {
  try {
    const { scheduleTypeId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getScheduleTypeById,
      scheduleTypeId,
    );
    if (response?.success) {
      yield put(actions.fetchScheduleTypeByIdSuccess(response.values));
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to fetch schedule type details.";
      yield put(actions.fetchScheduleTypeByIdFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch schedule type details.";
    yield put(actions.fetchScheduleTypeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// save schedule type saga
function* saveScheduleTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveScheduleType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveScheduleTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Schedule Type.",
      });
      yield put(actions.fetchScheduleTypeRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save schedule type.";
      yield put(actions.saveScheduleTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save schedule type.";
    yield put(actions.saveScheduleTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// delete schedule type saga
function* deleteScheduleTypeSaga(action) {
  try {
    const { scheduleTypeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteScheduleType,
      scheduleTypeId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteScheduleTypeSuccess(scheduleTypeId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Schedule Type.",
      });
      yield put(actions.fetchScheduleTypeRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete schedule type.";
      yield put(actions.deleteScheduleTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete schedule type.";
    yield put(actions.deleteScheduleTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate schedule type
function* activateDeactivateScheduleTypeSaga(action) {
  try {
    const { scheduleTypeId, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateScheduleType,
      scheduleTypeId,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateScheduleTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Schedule Type has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchScheduleTypeRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to update schedule type status.";
      yield put(actions.activateDeactivateScheduleTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update schedule type status.";
    yield put(actions.activateDeactivateScheduleTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Time Zone Sagas------------------//
function* fetchTimeZonesRequestsaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.fetchTimeZones);
    if (!response) {
      throw new Error("No response received from API");
    }
    // Extract the correct array from the response structure
    // The API returns { listTimeZone: [...] } so we need to extract that array
    const timezoneList = response?.values.listTimeZone || [];
    // Dispatch success action with the extracted array
    yield put(actions.fetchTimeZonesSuccess(timezoneList));
  } catch (error) {
    let errorMessage = "Failed to fetch time zones";
    // Dispatch failure action with error
    yield put(actions.fetchTimeZonesFailure(errorMessage));
  }
}

function* fetchTimeZoneByIdRequestsaga(action) {
  try {
    // Call the API
    const response = yield call(
      dropdownMgmtServices.getTimeZoneById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchTimeZoneByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Time Zone details";

    console.error("Fetch Time Zone By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchTimeZoneByIdFailure(errorMessage));
  }
}

function* saveTimeZoneRequestsaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveTimeZone,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveTimeZoneSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Time Zone.",
      });
      yield put(actions.fetchTimeZonesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save Time Zone.";
      yield put(actions.saveTimeZoneFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Time Zone.";
    yield put(actions.saveTimeZoneFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteTimeZoneRequestsaga(action) {
  try {
    const { TimeZoneID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteTimeZone,
      TimeZoneID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteTimeZoneSuccess(TimeZoneID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Time Zone.",
      });
      yield put(actions.fetchTimeZonesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Time Zone.";
      yield put(actions.deleteTimeZoneFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Time Zone.";
    yield put(actions.deleteTimeZoneFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateTimeZonesaga(action) {
  try {
    const { timeZoneId, isActive, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateTimeZone,
      timeZoneId,
      isActive,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateTimeZoneSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${isActive ? "activated" : "deactivated"} Time Zone.`,
      });
      yield put(actions.fetchTimeZonesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${isActive ? "activate" : "deactivate"} Time Zone.`;
      yield put(actions.activateDeactivateTimeZoneFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update time zone status.";
    yield put(actions.activateDeactivateTimeZoneFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Request Status Sagas------------------//
//get all Request status start from here
function* fetchRequeststatusTypeSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllRequestStatus);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchRequeststatusSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Request Status.";

    console.error("Request Status API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchRequeststatusFailure(errorMessage));
  }
}

// Fetch Request Status By ID Saga
function* fetchRequeststatusByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getRequestStatusById,
      action.payload,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchRequeststatusByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Request Status details";
    console.error("Fetch Request Status By ID API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    // Dispatch failure action with error
    yield put(actions.fetchRequeststatusByIdFailure(errorMessage));
  }
}

// save Requeststatus Type
function* saveRequeststatusTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveRequestStatus,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.saveRequeststatusSuccess(response?.message || response),
      );
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully Saved Request Status.",
      });
      yield put(actions.fetchRequeststatusRequest());
      yield put(
        actions.updateDropdownMgmtReducer({ selectedRequestStatus: null }),
      );
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Request Status.";
      yield put(actions.saveRequeststatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Request Status.";
    yield put(actions.saveRequeststatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// delete RequestStatus Saga
function* deleteRequeststatusSaga(action) {
  try {
    const { RadScheduleRequestStatusID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteRequestStatus,
      RadScheduleRequestStatusID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteRequeststatusSuccess(RadScheduleRequestStatusID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully deleted Request Status.",
      });
      yield put(actions.fetchRequeststatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Request Status.";
      yield put(actions.deleteRequeststatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Request Status.";
    yield put(actions.deleteRequeststatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateRequestStatussaga(action) {
  try {
    const { Id, Status, UserId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateRequestStatus,
      Id,
      Status,
      UserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateRequeststatusSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Request Status.`,
      });
      yield put(actions.fetchRequeststatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${Status ? "activate" : "deactivate"} Request Status.`;
      yield put(actions.activateDeactivateRequeststatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to activate/deactivate Request Status.";
    yield put(actions.activateDeactivateRequeststatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Site Status Sagas------------------//
// ===== SITE STATUS SECTION =====
function* fetchSiteStatusSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllSiteStatus);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchSiteStatusSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Site Status";

    console.error("Site Status API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchSiteStatusFailure(errorMessage));
  }
}

function* fetchSiteStatusByIdSaga(action) {
  try {
    const { SiteStatusID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getSiteStatusById,
      SiteStatusID,
    );
    yield put(actions.fetchSiteStatusByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Site Status details.";
    yield put(actions.fetchSiteStatusByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* saveSiteStatusSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveSiteStatus,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveSiteStatusSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Site Status.",
      });
      yield put(actions.fetchSiteStatusRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save Site Status.";
      yield put(actions.saveSiteStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Site Status.";
    yield put(actions.saveSiteStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteSiteStatusSaga(action) {
  try {
    const { siteStatusId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteSiteStatus,
      siteStatusId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteSiteStatusSuccess(siteStatusId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Site Status.",
      });
      yield put(actions.fetchSiteStatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Site Status.";
      yield put(actions.deleteSiteStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Site Status.";
    yield put(actions.deleteSiteStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateSiteStatusSaga(action) {
  try {
    const { Id, Status, UserId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateSiteStatus,
      Id,
      Status,
      UserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateSiteStatusSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Site Status.`,
      });
      yield put(actions.fetchSiteStatusRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${Status ? "activate" : "deactivate"} Site Status.`;
      yield put(actions.activateDeactivateSiteStatusFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update Site Status status.";
    yield put(actions.activateDeactivateSiteStatusFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Encore Section Sagas------------------//
function* fetchQgendaSectionSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllQgendaSections);
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchQgendaSectionsSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Encore Sections";

    console.error("Encore Sections API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchQgendaSectionsFailure(errorMessage));
  }
}

function* fetchQgendaSectionByIdSaga(action) {
  try {
    const { QGendaSectionID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getQgendaSectionById,
      QGendaSectionID,
    );
    yield put(actions.fetchQgendaSectionByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Encore Section details.";
    yield put(actions.fetchQgendaSectionByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* saveQgendaSectionSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveQgendaSection,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveQgendaSectionSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Encore Section.",
      });
      yield put(actions.fetchQgendaSectionsRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save Encore Section.";
      yield put(actions.saveQgendaSectionFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Encore Section.";
    yield put(actions.saveQgendaSectionFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteQgendaSectionSaga(action) {
  try {
    const { QGendaSectionID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteQgendaSection,
      QGendaSectionID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteQgendaSectionSuccess(QGendaSectionID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Encore Section.",
      });
      yield put(actions.fetchQgendaSectionsRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Encore Section.";
      yield put(actions.deleteQgendaSectionFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Encore Section.";
    yield put(actions.deleteQgendaSectionFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateQgendaSectionSaga(action) {
  try {
    const { Id, Status, UserId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateQgendaSection,
      Id,
      Status,
      UserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateQgendaSectionSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Encore Section.`,
      });
      yield put(actions.fetchQgendaSectionsRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${Status ? "activate" : "deactivate"} Encore Section.`;
      yield put(actions.activateDeactivateQgendaSectionFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update Encore Section status.";
    yield put(actions.activateDeactivateQgendaSectionFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Trauma Facility Level Sagas------------------//
// Worker saga for TraumaFacilityLevel getAll actions
function* fetchTraumaFacilityLevelSaga() {
  try {
    // Call the API
    const response = yield call(dropdownMgmtServices.getAllTraumaFacilityLevel);
    if (!response) {
      throw new Error("No response received from API");
    }

    // The API returns data in response.values.listTramaFacilityLevel
    const traumaFacilityLevelData =
      response?.values?.listTramaFacilityLevel || [];

    // Filter out deleted records (soft delete handling)
    const activeRecords = traumaFacilityLevelData.filter(
      (item) => !item.IsDeleted,
    );

    // Dispatch success action with the filtered data
    yield put(actions.fetchTraumaFacilityLevelSuccess(activeRecords));
  } catch (error) {
    let errorMessage = "Failed to fetch Trauma Facility Level";

    console.error("TraumaFacilityLevel API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchTraumaFacilityLevelFailure(errorMessage));
  }
}

// Worker saga for delete TraumaFacilityLevel
function* deleteTraumaFacilityLevelSaga(action) {
  try {
    const { TramaFacilityLevelID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteTraumaFacilityLevel,
      TramaFacilityLevelID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteTraumaFacilityLevelSuccess(TramaFacilityLevelID));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          "Successfully deleted Trauma Facility Level.",
      });
      yield put(actions.fetchTraumaFacilityLevelRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Trauma Facility Level.";
      yield put(actions.deleteTraumaFacilityLevelFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Trauma Facility Level.";
    yield put(actions.deleteTraumaFacilityLevelFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate TraumaFacilityLevel
function* activateDeactivateTraumaFacilityLevelSaga(action) {
  try {
    const { TramaFacilityLevelID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateTraumaFacilityLevel,
      TramaFacilityLevelID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateTraumaFacilityLevelSuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${status ? "activated" : "deactivated"} Trauma Facility Level.`,
      });
      yield put(actions.fetchTraumaFacilityLevelRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} Trauma Facility Level.`;
      yield put(
        actions.activateDeactivateTraumaFacilityLevelFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to activate/deactivate Trauma Facility Level.";
    yield put(
      actions.activateDeactivateTraumaFacilityLevelFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save TraumaFacilityLevel
function* saveTraumaFacilityLevelSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveTraumaFacilityLevel,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.saveTraumaFacilityLevelSuccess(response?.message || response),
      );
      yield put(actions.fetchTraumaFacilityLevelRequest());
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully saved Trauma Facility Level.",
      });
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Trauma Facility Level.";
      yield put(actions.saveTraumaFacilityLevelFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Trauma Facility Level.";
    yield put(actions.saveTraumaFacilityLevelFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for TraumaFacilityLevel fetchById action
function* fetchTraumaFacilityLevelByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getTraumaFacilityLevelById,
      action.payload?.TramaFacilityLevelID,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchTraumaFacilityLevelByIdSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Trauma Facility Level details";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
    // Dispatch failure action with error
    yield put(actions.fetchTraumaFacilityLevelByIdFailure(errorMessage));
  }
}

//Staff Category Sagas
function* fetchStaffCategoriesSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllStaffCategories);
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.fetchStaffCategoriesSuccess(response?.data || response),
      );
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to fetch Staff Categories.";
      yield put(actions.fetchStaffCategoriesFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Staff Categories.";
    yield put(actions.fetchStaffCategoriesFailure(errorMessage));
  }
}

function* saveStaffCategorySaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveStaffCategory,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(actions.saveStaffCategorySuccess(response?.data || response));
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully Saved Staff Category.",
      });
      yield put(actions.fetchStaffCategoriesRequest());
      yield put(
        actions.updateDropdownMgmtReducer({ selectedStaffCategory: null }),
      );
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Staff Category.";
      yield put(actions.saveStaffCategoryFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Staff Category.";
    yield put(actions.saveStaffCategoryFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteStaffCategorySaga(action) {
  try {
    const { StaffCategoryId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteStaffCategory,
      StaffCategoryId,
      modifiedBy,
    );
    const resultMessage =
      response?.resultMessage || response?.errorMessage || response?.message;
    const isSuccess =
      response?.success === true ||
      response?.isSuccess === true ||
      resultMessage?.toLowerCase().startsWith("successfully");
    if (response && isSuccess) {
      yield put(actions.deleteStaffCategorySuccess(StaffCategoryId));
      SweetAlert.success({
        title: "Success!",
        text: resultMessage || "Successfully Deleted Staff Category.",
      });
      yield put(actions.fetchStaffCategoriesRequest());
    } else {
      const errorMessage = resultMessage || "Failed to delete Staff Category.";
      yield put(actions.deleteStaffCategoryFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Staff Category.";
    yield put(actions.deleteStaffCategoryFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateStaffCategorySaga(action) {
  try {
    const { Id, Status, UserId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateStaffCategory,
      Id,
      Status,
      UserId,
    );
    const resultMessage =
      response?.resultMessage || response?.errorMessage || response?.message;
    const isSuccess =
      response?.success === true ||
      response?.isSuccess === true ||
      resultMessage?.toLowerCase().startsWith("successfully");
    if (response && isSuccess) {
      yield put(
        actions.activateDeactivateStaffCategorySuccess(
          response?.data || response,
        ),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Staff Category.`,
      });
      yield put(actions.fetchStaffCategoriesRequest());
    } else {
      const errorMessage =
        resultMessage || "Failed to activate/deactivate Staff Category.";
      yield put(actions.activateDeactivateStaffCategoryFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to activate/deactivate Staff Category.";
    yield put(actions.activateDeactivateStaffCategoryFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* fetchStaffCategoryByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getStaffCategoryById,
      action.payload?.StaffCategoryId,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.fetchStaffCategoryByIdSuccess(response?.data || response),
      );
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to fetch Staff Category by ID.";
      yield put(actions.fetchStaffCategoryByIdFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Staff Category by ID.";
    yield put(actions.fetchStaffCategoryByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//Staff Primary Location Sagas
function* fetchStaffPrimaryLocationsSaga() {
  try {
    const response = yield call(
      dropdownMgmtServices.getAllStaffPrimaryLocations,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.fetchStaffPrimaryLocationsSuccess(
          response.values?.lstStaffPrimaryWorkLocation,
        ),
      );
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to fetch Staff Primary Locations.";
      yield put(actions.fetchStaffPrimaryLocationsFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Staff Primary Locations.";
    yield put(actions.fetchStaffPrimaryLocationsFailure(errorMessage));
  }
}

function* saveStaffPrimaryLocationSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveStaffPrimaryLocation,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(
        actions.saveStaffPrimaryLocationSuccess(response?.data || response),
      );
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully Saved Staff Primary Location.",
      });
      yield put(actions.fetchStaffPrimaryLocationsRequest());
      yield put(
        actions.updateDropdownMgmtReducer({
          selectedStaffPrimaryLocation: null,
        }),
      );
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Staff Primary Location.";
      yield put(actions.saveStaffPrimaryLocationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Staff Primary Location.";
    yield put(actions.saveStaffPrimaryLocationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* deleteStaffPrimaryLocationSaga(action) {
  try {
    const { staffPrimaryLocationId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteStaffPrimaryLocation,
      staffPrimaryLocationId,
    );
    const resultMessage =
      response?.resultMessage || response?.errorMessage || response?.message;
    const isSuccess =
      response?.success === true ||
      response?.isSuccess === true ||
      resultMessage?.toLowerCase().startsWith("successfully");
    if (response && isSuccess) {
      yield put(
        actions.deleteStaffPrimaryLocationSuccess(staffPrimaryLocationId),
      );
      SweetAlert.success({
        title: "Success!",
        text: resultMessage || "Successfully Deleted Staff Primary Location.",
      });
      yield put(actions.fetchStaffPrimaryLocationsRequest());
    } else {
      const errorMessage =
        resultMessage || "Failed to delete Staff Primary Location.";
      yield put(actions.deleteStaffPrimaryLocationFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Staff Primary Location.";
    yield put(actions.deleteStaffPrimaryLocationFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateStaffPrimaryLocationSaga(action) {
  try {
    const { Id, Status } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateStaffPrimaryLocation,
      Id,
      Status,
    );
    const resultMessage =
      response?.resultMessage || response?.errorMessage || response?.message;
    const isSuccess =
      response?.success === true ||
      response?.isSuccess === true ||
      resultMessage?.toLowerCase().startsWith("successfully");
    if (response && isSuccess) {
      yield put(
        actions.activateDeactivateStaffPrimaryLocationSuccess(
          response?.data || response,
        ),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          resultMessage ||
          `Successfully ${Status ? "activated" : "deactivated"} Staff Primary Location.`,
      });
      yield put(actions.fetchStaffPrimaryLocationsRequest());
    } else {
      const errorMessage =
        resultMessage ||
        "Failed to activate/deactivate Staff Primary Location.";
      yield put(
        actions.activateDeactivateStaffPrimaryLocationFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to activate/deactivate Staff Primary Location.";
    yield put(
      actions.activateDeactivateStaffPrimaryLocationFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* fetchStaffPrimaryLocationByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getStaffPrimaryLocationById,
      action.payload?.StaffPrimaryLocationId,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(actions.fetchStaffPrimaryLocationByIdSuccess(response.values));
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to fetch Staff Primary Location by ID.";
      yield put(actions.fetchStaffPrimaryLocationByIdFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Staff Primary Location by ID.";
    yield put(actions.fetchStaffPrimaryLocationByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}
//------------------Modality Sagas------------------//
function* fetchModalitySaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllModality);
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.fetchModalitySuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch modalities";
    console.error("Fetch Modality API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    // Dispatch failure action with error
    yield put(actions.fetchModalityFailure(errorMessage));
  }
}

function* deleteModalitySaga(action) {
  try {
    const { ModalityId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteModality,
      ModalityId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteModalitySuccess(ModalityId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully deleted modality.",
      });
      yield put(actions.fetchModalityRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete modality.";
      yield put(actions.deleteModalityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete modality.";
    yield put(actions.deleteModalityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivateModalitySaga(action) {
  try {
    const { ModalityId, status, userId, Status, UserId } = action.payload;
    const resolvedStatus = typeof status !== "undefined" ? status : Status;
    const resolvedUserId = typeof userId !== "undefined" ? userId : UserId;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateModality,
      ModalityId,
      resolvedStatus,
      resolvedUserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateModalitySuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${resolvedStatus ? "activated" : "deactivated"} modality.`,
      });
      yield put(actions.fetchModalityRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${resolvedStatus ? "activate" : "deactivate"} modality.`;
      yield put(actions.activateDeactivateModalityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update modality status.";
    yield put(actions.activateDeactivateModalityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* saveModalitySaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveModality,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(actions.saveModalitySuccess(response?.message || response));
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully saved modality.",
      });
      yield put(actions.fetchModalityRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save modality.";
      yield put(actions.saveModalityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save modality.";
    yield put(actions.saveModalityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* fetchModalityByIdSaga(action) {
  try {
    const ModalityId =
      typeof action.payload === "object" && action.payload !== null
        ? action.payload.ModalityId
        : action.payload;
    const response = yield call(
      dropdownMgmtServices.getModalityById,
      ModalityId,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchModalityByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch modality details.";
    yield put(actions.fetchModalityByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Priority Sagas------------------//
function* fetchPrioritySaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(dropdownMgmtServices.getAllPriority);
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.fetchPrioritySuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch priorities";
    console.error("Fetch Priority API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    // Dispatch failure action with error
    yield put(actions.fetchPriorityFailure(errorMessage));
  }
}

function* deletePrioritySaga(action) {
  try {
    const { PriorityId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deletePriority,
      PriorityId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deletePrioritySuccess(PriorityId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully deleted Priority.",
      });
      yield put(actions.fetchPriorityRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Priority.";
      yield put(actions.deletePriorityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Priority.";
    yield put(actions.deletePriorityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* activateDeactivatePrioritySaga(action) {
  try {
    const { PriorityId, status, userId, Status, UserId } = action.payload;
    const resolvedStatus = typeof status !== "undefined" ? status : Status;
    const resolvedUserId = typeof userId !== "undefined" ? userId : UserId;
    const response = yield call(
      dropdownMgmtServices.activateDeactivatePriority,
      PriorityId,
      resolvedStatus,
      resolvedUserId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivatePrioritySuccess());
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Successfully ${resolvedStatus ? "activated" : "deactivated"} Priority.`,
      });
      yield put(actions.fetchPriorityRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${resolvedStatus ? "activate" : "deactivate"} Priority.`;
      yield put(actions.activateDeactivatePriorityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update Priority status.";
    yield put(actions.activateDeactivatePriorityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* savePrioritySaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.savePriority,
      action.payload,
    );
    if (
      response &&
      (response.success === true || response.isSuccess === true)
    ) {
      yield put(actions.savePrioritySuccess(response?.message || response));
      SweetAlert.success({
        title: "Success!",
        text: response?.message || "Successfully saved Priority.",
      });
      yield put(actions.fetchPriorityRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Priority.";
      yield put(actions.savePriorityFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Priority.";
    yield put(actions.savePriorityFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

function* fetchPriorityByIdSaga(action) {
  try {
    const { PriorityId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getPriorityById,
      PriorityId,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchPriorityByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Priority details.";
    yield put(actions.fetchPriorityByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Priority Bucket Sagas------------------//
function* fetchPriorityBucketsSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllPriorityBuckets);
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchPriorityBucketsSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch priority buckets";
    yield put(actions.fetchPriorityBucketsFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Specialty Cases Sagas------------------//
function* fetchSpecialtyCasesSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllSpecialtyCases);
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchSpecialtyCasesSuccess(response?.values));
  } catch (error) {
    const errorMessage = "Failed to fetch specialty cases";
    yield put(actions.fetchSpecialtyCasesFailure(errorMessage));
  }
}

function* fetchSpecialtyCasesByIdSaga(action) {
  try {
    const { SpecialtyCaseID } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getSpecialtyCaseById,
      SpecialtyCaseID,
    );
    yield put(actions.fetchSpecialtyCasesByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch specialty case details.";
    yield put(actions.fetchSpecialtyCasesByIdFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* saveSpecialtyCasesSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveSpecialtyCase,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveSpecialtyCasesSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully saved specialty case.",
      });
      yield put(actions.fetchSpecialtyCasesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save specialty case.";
      yield put(actions.saveSpecialtyCasesFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save specialty case.";
    yield put(actions.saveSpecialtyCasesFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* deleteSpecialtyCasesSaga(action) {
  try {
    const { SpecialtyCaseID, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteSpecialtyCase,
      SpecialtyCaseID,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteSpecialtyCasesSuccess(SpecialtyCaseID));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully deleted specialty case.",
      });
      yield put(actions.fetchSpecialtyCasesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete specialty case.";
      yield put(actions.deleteSpecialtyCasesFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete specialty case.";
    yield put(actions.deleteSpecialtyCasesFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* activateDeactivateSpecialtyCasesSaga(action) {
  try {
    const { SpecialtyCaseID, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateSpecialtyCase,
      SpecialtyCaseID,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateSpecialtyCasesSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Specialty case has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchSpecialtyCasesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} specialty case.`;
      yield put(actions.activateDeactivateSpecialtyCasesFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update specialty case status.";
    yield put(actions.activateDeactivateSpecialtyCasesFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

//------------------Staffing Agency Sagas------------------//
function* fetchStaffingAgencySaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllStaffingAgency);
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchStaffingAgencySuccess(response?.values));
  } catch (error) {
    const errorMessage = "Failed to fetch staffing agencies";
    yield put(actions.fetchStaffingAgencyFailure(errorMessage));
  }
}

function* fetchStaffingAgencyByIdSaga(action) {
  try {
    const { staffingAgencyId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.getStaffingAgencyById,
      staffingAgencyId,
    );
    yield put(actions.fetchStaffingAgencyByIdSuccess(response?.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch staffing agency details.";
    yield put(actions.fetchStaffingAgencyByIdFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* saveStaffingAgencySaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveStaffingAgency,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveStaffingAgencySuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully saved staffing agency.",
      });
      yield put(actions.fetchStaffingAgencyRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save staffing agency.";
      yield put(actions.saveStaffingAgencyFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save staffing agency.";
    yield put(actions.saveStaffingAgencyFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* deleteStaffingAgencySaga(action) {
  try {
    const { staffingAgencyId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteStaffingAgency,
      staffingAgencyId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteStaffingAgencySuccess(staffingAgencyId));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage || "Successfully deleted staffing agency.",
      });
      yield put(actions.fetchStaffingAgencyRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete staffing agency.";
      yield put(actions.deleteStaffingAgencyFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete staffing agency.";
    yield put(actions.deleteStaffingAgencyFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* activateDeactivateStaffingAgencySaga(action) {
  try {
    const { staffingAgencyId, status, userId } = action.payload;
    const response = yield call(
      dropdownMgmtServices.activateDeactivateStaffingAgency,
      staffingAgencyId,
      status,
      userId,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateStaffingAgencySuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Staffing agency has been ${status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchStaffingAgencyRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${status ? "activate" : "deactivate"} staffing agency.`;
      yield put(actions.activateDeactivateStaffingAgencyFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update staffing agency status.";
    yield put(actions.activateDeactivateStaffingAgencyFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

//------------------Provider Document Type------------------//
// Worker saga: will be fired on FETCH_PROVIDER_DOCUMENTTYPES_REQUEST actions
function* fetchProviderDocumentTypesSaga() {
  try {
    // Call the API - request utility already returns response.data
    const response = yield call(
      dropdownMgmtServices.getAllProviderDocumentTypes,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    // Dispatch success action with the data
    yield put(actions.fetchProviderDocumentTypesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch provider Types";

    console.error("Provider Type API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.fetchProviderDocumentTypesFailure(errorMessage));
  }
}

// Worker saga for delete provider Document Type
function* deleteProviderDocumentTypeSaga(action) {
  try {
    const { documentTypeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteProviderDocumentType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.deleteProviderDocumentTypeSuccess(documentTypeId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted provider Type.",
      });
      yield put(actions.fetchProviderDocumentTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete provider Type.";
      yield put(actions.deleteProviderDocumentTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete provider Type.";
    yield put(actions.deleteProviderDocumentTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save provider Document Type
function* saveProviderDocumentTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveProviderDocumentType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveProviderDocumentTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved provider Type.",
      });
      yield put(actions.fetchProviderDocumentTypesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save provider Type.";
      yield put(actions.saveProviderDocumentTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save provider Type.";
    yield put(actions.saveProviderDocumentTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for fetch provider Document Type by ID
function* fetchProviderDocumentTypeByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getProviderDocumentTypeById,
      action.payload,
    );
    yield put(actions.fetchProviderDocumentTypeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch provider Type details.";
    yield put(actions.fetchProviderDocumentTypeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for update provider Document Type
function* updateProviderDocumentTypeSaga(action) {
  try {
    const radTypeData = action.payload;
    const userData = yield call(getCookie, "userData");
    const userId = userData?.UserId || userData?.UserID || 10;
    const payload = {
      radTypeID: radTypeData.radTypeID || radTypeData.radTypeId,
      radTypeName: radTypeData.radTypeName,
      radTypeCode: radTypeData.radTypeCode || "",
      isActive: radTypeData.isActive,
      ModifiedBy: userId,
    };
    const response = yield call(dropdownMgmtServices.updateRadType, payload);
    if (response?.success) {
      yield put(actions.updateProviderDocumentTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Updated provider Type.",
      });
      yield put(actions.fetchProviderDocumentTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to update provider Type.";
      yield put(actions.updateProviderDocumentTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider Type.";
    yield put(actions.updateProviderDocumentTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate provider Document Type
function* activateDeactivateProviderDocumentTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.activateDeactivateProviderDocumentType,
      action.payload,
    );
    if (response?.success) {
      yield put(
        actions.activateDeactivateProviderDocumentTypeSuccess(response),
      );
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider Type has been ${action.payload.Status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchProviderDocumentTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${action.payload.Status ? "activate" : "deactivate"} provider Type.`;
      yield put(
        actions.activateDeactivateProviderDocumentTypeFailure(errorMessage),
      );
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update provider Type status.";
    yield put(
      actions.activateDeactivateProviderDocumentTypeFailure(errorMessage),
    );
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

//------------------Provider Note Type------------------//
// Worker saga: will be fired on FETCH_PROVIDER_NOTETYPES_REQUEST actions
function* fetchProviderNoteTypesSaga() {
  try {
    const response = yield call(dropdownMgmtServices.getAllProviderNoteTypes);
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(actions.fetchProviderNoteTypesSuccess(response?.values));
  } catch (error) {
    let errorMessage = "Failed to fetch Provider Note Types";
    console.error("Provider Note Type API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
    });
    yield put(actions.fetchProviderNoteTypesFailure(errorMessage));
  }
}

// Worker saga for fetch Provider Note Type by ID
function* fetchProviderNoteTypeByIdSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.getProviderNoteTypeById,
      action.payload,
    );
    yield put(actions.fetchProviderNoteTypeByIdSuccess(response.values));
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to fetch Provider Note Type details.";
    yield put(actions.fetchProviderNoteTypeByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for save Provider Note Type
function* saveProviderNoteTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.saveProviderNoteType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveProviderNoteTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Saved Provider Note Type.",
      });
      yield put(actions.fetchProviderNoteTypesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save Provider Note Type.";
      yield put(actions.saveProviderNoteTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to save Provider Note Type.";
    yield put(actions.saveProviderNoteTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for delete Provider Note Type
function* deleteProviderNoteTypeSaga(action) {
  try {
    const { noteTypeId, modifiedBy } = action.payload;
    const response = yield call(
      dropdownMgmtServices.deleteProviderNoteType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.deleteProviderNoteTypeSuccess(noteTypeId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Successfully Deleted Provider Note Type.",
      });
      yield put(actions.fetchProviderNoteTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to delete Provider Note Type.";
      yield put(actions.deleteProviderNoteTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to delete Provider Note Type.";
    yield put(actions.deleteProviderNoteTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Worker saga for activate/deactivate Provider Note Type
function* activateDeactivateProviderNoteTypeSaga(action) {
  try {
    const response = yield call(
      dropdownMgmtServices.activateDeactivateProviderNoteType,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateProviderNoteTypeSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Provider Note Type has been ${action.payload.Status ? "activated" : "deactivated"} successfully.`,
      });
      yield put(actions.fetchProviderNoteTypesRequest());
    } else {
      const errorMessage =
        response?.errorMessage ||
        `Failed to ${action.payload.Status ? "activate" : "deactivate"} Provider Note Type.`;
      yield put(actions.activateDeactivateProviderNoteTypeFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.message ||
      "Failed to update Provider Note Type status.";
    yield put(actions.activateDeactivateProviderNoteTypeFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
    });
  }
}

// Watcher saga: spawns new saga tasks on each request
function* dropdownMgmtSaga() {
  yield takeEvery(types.FETCH_RADTYPES_REQUEST, fetchRadTypesSaga);
  yield takeEvery(types.DELETE_RADTYPE_REQUEST, deleteRadTypeSaga);
  yield takeEvery(types.SAVE_RADTYPE_REQUEST, saveRadTypeSaga);
  yield takeEvery(types.FETCH_RADTYPE_BY_ID_REQUEST, fetchRadTypeByIdSaga);
  yield takeEvery(types.UPDATE_RADTYPE_REQUEST, updateRadTypeSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_RADTYPE_REQUEST,
    activateDeactivateRadTypeSaga,
  );

  yield takeEvery(types.FETCH_RADSTATUS_REQUEST, fetchRadStatusSaga);
  yield takeEvery(types.DELETE_RADSTATUS_REQUEST, deleteRadStatusSaga);
  yield takeEvery(types.SAVE_RADSTATUS_REQUEST, saveRadStatusSaga);
  yield takeEvery(types.FETCH_RADSTATUS_BY_ID_REQUEST, fetchRadStatusByIdSaga);
  yield takeEvery(types.UPDATE_RADSTATUS_REQUEST, updateRadStatusSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_RADSTATUS_REQUEST,
    activateDeactivateRadStatusSaga,
  );

  yield takeEvery(
    types.FETCH_SUBSPECIALITIES_REQUEST,
    fetchSubspecialitiesSaga,
  );
  yield takeEvery(
    types.FETCH_SUBSPECIALITY_BY_ID_REQUEST,
    fetchSubspecialityByIdSaga,
  );
  yield takeEvery(types.SAVE_SUBSPECIALITY_REQUEST, saveSubspecialitySaga);
  yield takeEvery(types.DELETE_SUBSPECIALITY_REQUEST, deleteSubspecialitySaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_REQUEST,
    activateDeactivateSubspecialitySaga,
  );

  yield takeEvery(
    types.FETCH_BILLING_MANAGEMENT_REQUEST,
    fetchBillingManagementSaga,
  );
  yield takeEvery(
    types.FETCH_BILLING_MANAGEMENT_BY_ID_REQUEST,
    fetchBillingManagementByIdSaga,
  );
  yield takeEvery(
    types.SAVE_BILLING_MANAGEMENT_REQUEST,
    saveBillingManagementSaga,
  );
  yield takeEvery(
    types.DELETE_BILLING_MANAGEMENT_REQUEST,
    deleteBillingManagementSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_REQUEST,
    activateDeactivateBillingManagementSaga,
  );

  //Week Rotation Sagas
  yield takeEvery(types.FETCH_WEEK_ROTATIONS_REQUEST, fetchWeekRotationsSaga);
  yield takeEvery(
    types.FETCH_WEEK_ROTATION_BY_ID_REQUEST,
    fetchWeekRotationByIdSaga,
  );
  yield takeEvery(types.SAVE_WEEK_ROTATION_REQUEST, saveWeekRotationSaga);
  yield takeEvery(types.DELETE_WEEK_ROTATION_REQUEST, deleteWeekRotationSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_REQUEST,
    activateDeactivateWeekRotationSaga,
  );

  //Week Rotation Template Sagas
  yield takeEvery(
    types.FETCH_WEEK_ROTATION_TEMPLATES_REQUEST,
    fetchWeekRotationTemplatesSaga,
  );
  yield takeEvery(
    types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST,
    fetchWeekRotationTemplateByIdSaga,
  );
  yield takeEvery(
    types.DELETE_WEEK_ROTATION_TEMPLATE_REQUEST,
    deleteWeekRotationTemplateSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_REQUEST,
    activateDeactivateWeekRotationTemplateSaga,
  );
  yield takeEvery(
    types.SAVE_WEEK_ROTATION_TEMPLATE_REQUEST,
    saveWeekRotationTemplateSaga,
  );

  yield takeEvery(
    types.FETCH_PARTNERSHIP_RATES_REQUEST,
    fetchPartnershipRatesSaga,
  );
  yield takeEvery(
    types.FETCH_PARTNERSHIP_RATE_BY_ID_REQUEST,
    fetchPartnershipRateByIdSaga,
  );
  yield takeEvery(types.SAVE_PARTNERSHIP_RATE_REQUEST, savePartnershipRateSaga);
  yield takeEvery(
    types.DELETE_PARTNERSHIP_RATE_REQUEST,
    deletePartnershipRateSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_REQUEST,
    activateDeactivatePartnershipRateSaga,
  );

  yield takeEvery(
    types.FETCH_PARTNERSHIP_STATUSES_REQUEST,
    fetchPartnershipStatusesSaga,
  );
  yield takeEvery(
    types.FETCH_PARTNERSHIP_STATUS_BY_ID_REQUEST,
    fetchPartnershipStatusByIdSaga,
  );
  yield takeEvery(
    types.SAVE_PARTNERSHIP_STATUS_REQUEST,
    savePartnershipStatusSaga,
  );
  yield takeEvery(
    types.DELETE_PARTNERSHIP_STATUS_REQUEST,
    deletePartnershipStatusSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_REQUEST,
    activateDeactivatePartnershipStatusSaga,
  );

  yield takeEvery(
    types.FETCH_PARTNERSHIP_TIMES_REQUEST,
    fetchPartnershipTimesSaga,
  );
  yield takeEvery(
    types.FETCH_PARTNERSHIP_TIME_BY_ID_REQUEST,
    fetchPartnershipTimeByIdSaga,
  );
  yield takeEvery(types.SAVE_PARTNERSHIP_TIME_REQUEST, savePartnershipTimeSaga);
  yield takeEvery(
    types.DELETE_PARTNERSHIP_TIME_REQUEST,
    deletePartnershipTimeSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_REQUEST,
    activateDeactivatePartnershipTimeSaga,
  );

  yield takeEvery(types.FETCH_RAD_DEGREE_REQUEST, fetchRadDegreeSaga);
  yield takeEvery(types.DELETE_RAD_DEGREE_REQUEST, deleteRadDegreeSaga);
  yield takeEvery(types.SAVE_RAD_DEGREE_REQUEST, saveRadDegreeSaga);
  yield takeEvery(types.FETCH_RAD_DEGREE_BY_ID_REQUEST, fetchRadDegreeByIdSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_RAD_DEGREE_REQUEST,
    activateDeactivateRadDegreeSaga,
  );

  yield takeEvery(
    types.FETCH_DESIGNATION_LOOKUP_REQUEST,
    fetchDesignationLookupSaga,
  );
  yield takeEvery(types.FETCH_DESIGNATION_REQUEST, fetchDesignationSaga);
  yield takeEvery(types.DELETE_DESIGNATION_REQUEST, deleteDesignationSaga);
  yield takeEvery(types.SAVE_DESIGNATION_REQUEST, saveDesignationSaga);
  yield takeEvery(
    types.FETCH_DESIGNATION_BY_ID_REQUEST,
    fetchDesignationByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_DESIGNATION_REQUEST,
    activateDeactivateDesignationSaga,
  );

  yield takeEvery(types.FETCH_COMMITTEES_REQUEST, fetchCommitteesSaga);
  yield takeEvery(
    types.FETCH_COMMITTEES_BY_ID_REQUEST,
    fetchCommitteesByIdSaga,
  );
  yield takeEvery(types.SAVE_COMMITTEES_REQUEST, saveCommitteesSaga);
  yield takeEvery(types.DELETE_COMMITTEES_REQUEST, deleteCommitteesSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_COMMITTEES_REQUEST,
    activateDeactivateCommitteesSaga,
  );

  yield takeEvery(
    types.FETCH_FUTURE_SECTION_CHANGE_REQUEST,
    fetchFutureSectionChangeSaga,
  );
  yield takeEvery(
    types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_REQUEST,
    fetchFutureSectionChangeByIdSaga,
  );
  yield takeEvery(
    types.SAVE_FUTURE_SECTION_CHANGE_REQUEST,
    saveFutureSectionChangeSaga,
  );
  yield takeEvery(
    types.DELETE_FUTURE_SECTION_CHANGE_REQUEST,
    deleteFutureSectionChangeSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_REQUEST,
    activateDeactivateFutureSectionChangeSaga,
  );

  yield takeEvery(types.FETCH_SCHEDULETYPE_REQUEST, fetchScheduleTypeSaga);
  yield takeEvery(types.DELETE_SCHEDULETYPE_REQUEST, deleteScheduleTypeSaga);
  yield takeEvery(types.SAVE_SCHEDULETYPE_REQUEST, saveScheduleTypeSaga);
  yield takeEvery(
    types.FETCH_SCHEDULETYPE_BY_ID_REQUEST,
    fetchScheduleTypeByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_REQUEST,
    activateDeactivateScheduleTypeSaga,
  );

  yield takeEvery(
    types.FETCH_RAD_COMMUNICATION_TYPE_REQUEST,
    fetchRadCommunicationTypeSaga,
  );
  yield takeEvery(
    types.DELETE_RAD_COMMUNICATION_TYPE_REQUEST,
    deleteRadCommunicationTypeSaga,
  );
  yield takeEvery(
    types.SAVE_RAD_COMMUNICATION_TYPE_REQUEST,
    saveRadCommunicationTypeSaga,
  );
  yield takeEvery(
    types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_REQUEST,
    fetchRadCommunicationTypeByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_REQUEST,
    activateDeactivateRadCommunicationTypeSaga,
  );

  // RVU Rate sagas - Fixed to use correct saga functions
  yield takeEvery(types.FETCH_RVURATE_REQUEST, fetchRvuRateRequestsSaga);
  yield takeEvery(types.FETCH_RVURATE_BY_ID_REQUEST, fetchRvuRateByIdSaga);
  yield takeEvery(types.SAVE_RVURATE_REQUEST, saveRvuRateRequestsSaga);
  yield takeEvery(types.DELETE_RVURATE_REQUEST, deleteRvuRateRequestsSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_RVURATE_REQUEST,
    activateDeactivateRvuRateRequestsSaga,
  );

  // Time Zone sagas
  yield takeEvery(types.FETCH_TIME_ZONES_REQUEST, fetchTimeZonesRequestsaga);
  yield takeEvery(
    types.FETCH_TIME_ZONE_BY_ID_REQUEST,
    fetchTimeZoneByIdRequestsaga,
  );
  yield takeEvery(types.SAVE_TIME_ZONE_REQUEST, saveTimeZoneRequestsaga);
  yield takeEvery(types.DELETE_TIME_ZONE_REQUEST, deleteTimeZoneRequestsaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_TIME_ZONE_REQUEST,
    activateDeactivateTimeZonesaga,
  );

  // Request Status Saga start from here
  yield takeEvery(
    types.FETCH_REQUESTSTATUS_REQUEST,
    fetchRequeststatusTypeSaga,
  );
  yield takeEvery(
    types.FETCH_REQUESTSTATUS_BY_ID_REQUEST,
    fetchRequeststatusByIdSaga,
  );
  yield takeEvery(types.SAVE_REQUESTSTATUS_REQUEST, saveRequeststatusTypeSaga);
  yield takeEvery(types.DELETE_REQUESTSTATUS_REQUEST, deleteRequeststatusSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_REQUEST,
    activateDeactivateRequestStatussaga,
  );

  // TraumaFacilityLevel Saga start from here
  yield takeEvery(
    types.FETCH_TRAUMAFACILITYLEVEL_REQUEST,
    fetchTraumaFacilityLevelSaga,
  );
  yield takeEvery(
    types.DELETE_TRAUMAFACILITYLEVEL_REQUEST,
    deleteTraumaFacilityLevelSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_REQUEST,
    activateDeactivateTraumaFacilityLevelSaga,
  );
  yield takeEvery(
    types.SAVE_TRAUMAFACILITYLEVEL_REQUEST,
    saveTraumaFacilityLevelSaga,
  );
  yield takeEvery(
    types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_REQUEST,
    fetchTraumaFacilityLevelByIdSaga,
  );

  // Encore Section sagas
  yield takeEvery(types.FETCH_QGENDA_SECTION_REQUEST, fetchQgendaSectionSaga);
  yield takeEvery(types.DELETE_QGENDA_SECTION_REQUEST, deleteQgendaSectionSaga);
  yield takeEvery(types.SAVE_QGENDA_SECTION_REQUEST, saveQgendaSectionSaga);
  yield takeEvery(
    types.FETCH_QGENDA_SECTION_BY_ID_REQUEST,
    fetchQgendaSectionByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_REQUEST,
    activateDeactivateQgendaSectionSaga,
  );

  // Site Status sagas
  yield takeEvery(types.FETCH_SITE_STATUS_REQUEST, fetchSiteStatusSaga);
  yield takeEvery(types.DELETE_SITE_STATUS_REQUEST, deleteSiteStatusSaga);
  yield takeEvery(types.SAVE_SITE_STATUS_REQUEST, saveSiteStatusSaga);
  yield takeEvery(
    types.FETCH_SITE_STATUS_BY_ID_REQUEST,
    fetchSiteStatusByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_SITE_STATUS_REQUEST,
    activateDeactivateSiteStatusSaga,
  );

  //Staff Category sagas
  yield takeEvery(
    types.FETCH_STAFF_CATEGORIES_REQUEST,
    fetchStaffCategoriesSaga,
  );
  yield takeEvery(types.SAVE_STAFF_CATEGORY_REQUEST, saveStaffCategorySaga);
  yield takeEvery(types.DELETE_STAFF_CATEGORY_REQUEST, deleteStaffCategorySaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_REQUEST,
    activateDeactivateStaffCategorySaga,
  );
  yield takeEvery(
    types.FETCH_STAFF_CATEGORY_BY_ID_REQUEST,
    fetchStaffCategoryByIdSaga,
  );

  // Staff Primary Location sagas (watcher entries below — functions defined above)
  yield takeEvery(
    types.FETCH_STAFF_PRIMARY_LOCATIONS_REQUEST,
    fetchStaffPrimaryLocationsSaga,
  );
  yield takeEvery(
    types.SAVE_STAFF_PRIMARY_LOCATION_REQUEST,
    saveStaffPrimaryLocationSaga,
  );
  yield takeEvery(
    types.DELETE_STAFF_PRIMARY_LOCATION_REQUEST,
    deleteStaffPrimaryLocationSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_REQUEST,
    activateDeactivateStaffPrimaryLocationSaga,
  );
  yield takeEvery(
    types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_REQUEST,
    fetchStaffPrimaryLocationByIdSaga,
  );
  // Modality sagas
  yield takeEvery(types.FETCH_MODALITY_REQUEST, fetchModalitySaga);
  yield takeEvery(types.DELETE_MODALITY_REQUEST, deleteModalitySaga);
  yield takeEvery(types.SAVE_MODALITY_REQUEST, saveModalitySaga);
  yield takeEvery(types.FETCH_MODALITY_BY_ID_REQUEST, fetchModalityByIdSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_MODALITY_REQUEST,
    activateDeactivateModalitySaga,
  );

  // Priority sagas
  yield takeEvery(types.FETCH_PRIORITY_REQUEST, fetchPrioritySaga);
  yield takeEvery(types.DELETE_PRIORITY_REQUEST, deletePrioritySaga);
  yield takeEvery(types.SAVE_PRIORITY_REQUEST, savePrioritySaga);
  yield takeEvery(types.FETCH_PRIORITY_BY_ID_REQUEST, fetchPriorityByIdSaga);
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PRIORITY_REQUEST,
    activateDeactivatePrioritySaga,
  );
  yield takeEvery(
    types.FETCH_PRIORITY_BUCKETS_REQUEST,
    fetchPriorityBucketsSaga,
  );

  // Specialty Cases sagas
  yield takeEvery(types.FETCH_SPECIALTY_CASES_REQUEST, fetchSpecialtyCasesSaga);
  yield takeEvery(
    types.FETCH_SPECIALTY_CASES_BY_ID_REQUEST,
    fetchSpecialtyCasesByIdSaga,
  );
  yield takeEvery(types.SAVE_SPECIALTY_CASES_REQUEST, saveSpecialtyCasesSaga);
  yield takeEvery(
    types.DELETE_SPECIALTY_CASES_REQUEST,
    deleteSpecialtyCasesSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_REQUEST,
    activateDeactivateSpecialtyCasesSaga,
  );

  // Staffing Agency sagas
  yield takeEvery(types.FETCH_STAFFING_AGENCY_REQUEST, fetchStaffingAgencySaga);
  yield takeEvery(
    types.FETCH_STAFFING_AGENCY_BY_ID_REQUEST,
    fetchStaffingAgencyByIdSaga,
  );
  yield takeEvery(types.SAVE_STAFFING_AGENCY_REQUEST, saveStaffingAgencySaga);
  yield takeEvery(
    types.DELETE_STAFFING_AGENCY_REQUEST,
    deleteStaffingAgencySaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_REQUEST,
    activateDeactivateStaffingAgencySaga,
  );

  // Provider Document Type sagas
  yield takeEvery(
    types.FETCH_PROVIDER_DOCUMENTTYPES_REQUEST,
    fetchProviderDocumentTypesSaga,
  );
  yield takeEvery(
    types.DELETE_PROVIDER_DOCUMENTTYPE_REQUEST,
    deleteProviderDocumentTypeSaga,
  );
  yield takeEvery(
    types.SAVE_PROVIDER_DOCUMENTTYPE_REQUEST,
    saveProviderDocumentTypeSaga,
  );
  yield takeEvery(
    types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_REQUEST,
    fetchProviderDocumentTypeByIdSaga,
  );
  yield takeEvery(
    types.UPDATE_PROVIDER_DOCUMENTTYPE_REQUEST,
    updateProviderDocumentTypeSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_REQUEST,
    activateDeactivateProviderDocumentTypeSaga,
  );

  // Provider Note Type sagas
  yield takeEvery(
    types.FETCH_PROVIDER_NOTETYPES_REQUEST,
    fetchProviderNoteTypesSaga,
  );
  yield takeEvery(
    types.DELETE_PROVIDER_NOTETYPE_REQUEST,
    deleteProviderNoteTypeSaga,
  );
  yield takeEvery(
    types.SAVE_PROVIDER_NOTETYPE_REQUEST,
    saveProviderNoteTypeSaga,
  );
  yield takeEvery(
    types.FETCH_PROVIDER_NOTETYPE_BY_ID_REQUEST,
    fetchProviderNoteTypeByIdSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_REQUEST,
    activateDeactivateProviderNoteTypeSaga,
  );
}

export default dropdownMgmtSaga;
